<template>
  <div class="main-content-container container">
    <div class="page-header row no-gutters py-4">
      <div class="col-6 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">sessão</span>
        <h3 class="page-title">Fluxo de Caixa</h3>
      </div>

      <!-- Filters -->
      <div class="col-6 d-flex">
        <div class="input-group d-flex justify-content-end my-auto">
          <button
            type="button"
            class="btn btn-primary btn-sm mt-3"
            @click="OpenModalFilter()"
          >
            <i class="fas fa-filter"></i>
            {{ countFilter > 0 ? "Filtros aplicados" : "" }}
            <span v-if="countFilter > 0" class="badge badge-light">{{
              countFilter
            }}</span>
          </button>
          <button
            v-if="countFilter > 0"
            type="button"
            class="input-group-text btn-sm ml-1 mt-3"
            v-b-tooltip.hover.bottom
            title="Limpar filtros"
            @click="ResetFilter()"
          >
            <i class="fas fa-eraser"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
            <div class="float-right">
              <b-input-group class="d-flex justify-content-end my-auto ml-2">
                <div
                  class="dropdown m-0"
                  :class="window.width < 1880 ? 'dropleft' : ''"
                >
                  <button
                    class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                    type="button"
                    v-b-tooltip.hover.right
                    title="Mais opções"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="fas fa-ellipsis-v"></i>
                  </button>
                  <div
                    class="dropdown-menu"
                    id="dropTableOptions"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <a
                      class="dropdown-item"
                      href="#"
                      :class="loadingReport ? 'disabled' : ''"
                      v-on:click.stop="GetReport($event)"
                    >
                      <template v-if="loadingReport">
                        <loader
                          :small="true"
                          :isLoading="loadingReport"
                        ></loader>
                      </template>
                      <template v-else>
                        <i class="fas fa-check mr-2"></i>
                        Gerar relatório
                      </template>
                    </a>
                  </div>
                </div>
              </b-input-group>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-center">
            <loader :is-loading="loadingList"></loader>
            <table class="table mb-0" v-if="!loadingList">
              <thead class="bg-s2p-gray-light">
                <tr>
                  <th scope="col" class="border-0"></th>
                  <th scope="col" class="border-0">Data</th>
                  <th scope="col" class="border-0">Saldo Inicial</th>
                  <th scope="col" class="border-0" style="border-left: 1px solid #dee2e6 !important;">Entradas</th>
                  <th scope="col" class="border-0" style="border-right: 1px solid #dee2e6 !important">Saídas</th>
                  <!-- <th scope="col" class="border-0">Caixa Diário</th> -->
                  <th scope="col" class="border-0">Saldo Final</th>
                  <th scope="col" class="border-0">Status</th>
                  <th scope="col" class="border-0"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(field, index) in fields"
                  :key="index"
                  :style="field.IsToday ? { 'font-weight': 'bolder', 'box-shadow' : 'rgb(233 233 233) 0px 3px 2px 2px, rgb(233 233 233) 0px 0px 9px 4px' } : {}"
                >


                <td></td>



                  <td >{{ field.Date | date("DD/MM/YYYY") }}</td>

                  <td :style="ItemTableColor(field.BalanceInitial)">
                    {{ field.BalanceInitial | currency }}
                  </td>


                  <td :style="ItemTableColor(field.AmountAccountsReceivable)" style="border-left: 1px solid #dee2e6 !important">
                    {{ field.AmountAccountsReceivable | currency }}
                  </td>
                  <td :style="ItemTableColor(field.AmountAccountsPayable)" style="border-right: 1px solid #dee2e6 !important">
                    {{ field.AmountAccountsPayable | currency }}
                  </td>
                  <!-- <td :style="ItemTableColor(field.NetCashFlow)">
                    {{ field.NetCashFlow | currency }}
                  </td> -->
                  <td :style="ItemTableColor(field.BalanceEnd)">
                    {{ field.BalanceEnd | currency }}
                  </td>
                  <td>

                    <span class="badge badge-success" v-if="field.IsRealized"><i class="fas fa-check"></i> Realizado</span>
                    <span class="badge badge-info" v-if="!field.IsRealized"><i class="fas fa-clock"></i> Projetado</span>



                    
                  </td>
                  <td></td>
                </tr>
                <tr
                  v-if="
                    fields == undefined || fields == null || fields.length == 0
                  "
                >
                  <td colspan="6">Sem registros</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      centered
      id="mFilter"
      title="Filtros"
    >
      <d-form-row>
        <d-col md="4" class="form-group">
          <label>Data para pesquisa</label>
          <date-field
            v-model="filter.Date"
            format="MMMM yyyy"
            minimumView="month"
          ></date-field>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          @click="Filter()"
          class="btn btn-primary"
          title="Pesquisar"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          @click="ResetFilter()"
          class="input-group-text"
          title="Limpar filtros"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";

//import TableListAPC from "../sub-components/AccountsPayableCategory/TableListAPC";

export default {
  name: "CashFlow",
  components: {
    dateField
  },
  data() {
    return {
      countFilter: 0,
      fields: [],
      filter: {
        Date: this.$options.filters.date(new Date(), "YYYY-MM-DD")
      },
      isSeeing: false,
      loadingList: false,
      loadingModal: false,
      pOpened: null,
      loadingReport: false,
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  mounted() {
    this.ListCashFlow();
  },
  methods: {
    ItemTableColor(value) {
      if (value != 0) {
        return value < 0 ? { color: "red" } : { color: "#0ac37f" };
      } else {
        return {};
      }
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      this.filter.IsMerchantRoot = this.isMerchantRoot;
      const params = {"Object.Date": this.filter.Date};
      this.$store
        .dispatch("ReportCashFlow", { params })
        .then((response) => {
          if (hasValue(response.UrlReport)) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListCashFlow();
    },
    ResetFilter() {
      this.filter = {
        Date: this.$options.filters.addMonth(new Date(), 0)
      };
      this.ListCashFlow();
    },
    ResetInfoField() {
      this.infoField = {
        Date: this.$options.filters.addMonth(new Date(), 0)
      };
    },
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },
    ListCashFlow() {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Date)) this.countFilter++;
      let data = {
        "Object.Date": this.filter.Date
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListCashFlow", { params: data })
        .then(response => {
          this.fields = response;
        })
        .catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger",
            "Erro ao listar os Campos",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    preventDecimal(e) {
      if (e.code == "Comma" || e.code == "Period" || e.code == "Minus") {
        e.preventDefault();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fa-green {
  color: #0ac37f;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/CashFlow.vue